import { observer } from "mobx-react-lite"

import type { WithdrawStore } from "@/domains/lock-page/withdraw-store"
import { ExternalTxLink } from "@/domains/common/components/external-tx-link"
import { MessageBoxIcon } from "@/domains/common/components/message-box-icon"
import { MultilineMessageBox } from "@/domains/common/components/multi-line-message-box"
import { ShortMessageBox } from "@/domains/common/components/short-message-box"
import { BodySM } from "@/domains/design/components/body-sm"
import { formatCurrency } from "@/domains/library"

interface WithdrawWithdrawAllowedProps {
  store: WithdrawStore
  governanceTokenSymbol?: string
}

export const WithdrawWithdrawAllowed = observer(
  ({ store, governanceTokenSymbol = "SCALE" }: WithdrawWithdrawAllowedProps) => {
    if (!store.lock) return null

    const Component = store.resetTxHash ? MultilineMessageBox : ShortMessageBox

    return (
      <Component variant="info" icon={<MessageBoxIcon size={"md"} variant="info" />}>
        <BodySM className="text-t200">
          You will receive {formatCurrency(store.lock.lockAmount)} {governanceTokenSymbol} from NFT #{store.lock.id}
        </BodySM>

        {store.resetTxHash && <ExternalTxLink url={store.resetTxHashUrl} title="View reset tx" className="mt-2" />}
      </Component>
    )
  },
)
